<template>
  <div class="main-container">
  <breadcrumb :list="breadcrumbList"/>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />

    <pop-up-message
      v-if="showSuccessBulkUploadMsg"
      :message="responseMsg"
      btnText="Back"
      @back="back"
    >
      <template v-slot:bottomContent>
        <div class=" margintop-32">
          <div class="Rectangle margintop-32">
            <span class="Information-message"></span>
          </div>
        </div>
        <div class="margintop-32 custom-container">
          <a :href="logSheetUrl" @click="downloadItem(logSheetUrl)">
            <img src="@/assets/download.svg"  class="img" /> <span class="text">Log Sheet</span></a>
        </div>
        <div class="popup-btn-group margintop-32 marginright">
          <button class="btn-popup" type="button" @click="backfromlogpopup()">Back</button>
        </div>
      </template>
    </pop-up-message>

    <tl-header type="h1">
      <div class="main-header">Create ESS Login</div>
    </tl-header>

    <div class="row margintop-10">
      <!-- <div>
        <tl-radio label="Manual" name="employee" id="manual" value="manual" @change="manualEntry" v-model="formData.manual" />
     </div> -->
      <div>
        <tl-radio label="Bulk Upload" name="employee" id="bulk" value="bulk" @change="bulkUpload" v-model="formData.manual"/>
      </div>
    </div>
    <div v-if="formData.manual=='manual'">

        
      <div class="filters-section">
        <!-- <div class="selectdiv">
          <tl-select class="ht-35"
            label="Select Entity"
            labelText="legalName"
            :options="legalEntitiesData"
            :v-model="formData.entityType"
            @change="(val)=>changeHandler(val)"
           ></tl-select>
        </div> -->
        <div class="selectdiv">
          <search-dropdown
            label="Select Employee"
            :employeeData="employeeData"
            @clear="(val) =>{clearEmployee()}"
            @getList="searchEmployeesByName($event)"
            @empselected="(emp)=>selectedEmp(emp)"
          />
        </div>
        <!-- <div class="selectdiv">
          <tl-select class="ht-35"
            label="Select Role"
            labelText="roleName"
            :options="['HR', 'EMPLOYEE']"
            :v-model="formData.roleType"
            @change="(val)=>(formData.roleType = val)"
           ></tl-select>
        </div> -->
        <div class="selectdiv">
          <txt
             label='Employee Email ID'
             type="text"
             class="ht-35"
             v-model='formData.email'
             placeholder="Enter Email"
             name="Email"
            />
            <!-- @onValueChange="save" -->
        </div>
       </div>
       <pop-up-message
          v-if="showSuccessMsg"
          :message="`ESS Login created for ${formData.email}.`"
          btnText="Back To EssManagement"
          @back="backfrompopup()"
        />
        <div class="grshowSuccessBulkUploadMsgoup-btn">
         <btn-grp>
            <btn text="Cancel" type="secondary" @click="cancel"/>
            <btn text="Submit" type="primary" v-on:click="performAction"></btn>
          </btn-grp>
       </div>
    </div>
    <div class="row" v-if="formData.manual == 'bulk'">
        <div class="col-12 margintop-32">
          <download-button
            @downloadTemplate="downloadTemplate"
          ></download-button>
        </div>
        <div class="col-12 margintop-16" :key="componentKey">
          <upload :tobucket="false" ref="bulkFile" @change="onUploadTemplate($event)"></upload>
        </div>
      </div>
 </div>
</template>

 <script>
import { mapState, mapActions, mapGetters } from "vuex";
import SearchDropdown from "@/components/TlSearchDropdown.vue";
export default {
  components: {
    SearchDropdown
  },
  data() {
    return {
      breadcrumbList:[
        {
          name:'Organisation',
          url:`/dashboard/${this.$route.params.entity_index}/organisation`
        },{
          name:'Utilities',
          url:`/dashboard/${this.$route.params.entity_index}/organisation/utilities`
        },{
          name:'Create ESS Login',
          url:`/dashboard/${this.$route.params.entity_index}/organisation/utilities/essLogin`
        }
      ],
      showCreateModal: false,
     
      employeeDetails: {},
      search: "",
      errmsg:"",
      showSuccessMsg: false,
      manual: true,
      auto_suggestions: false,
      toast: false,
      showSuccessBulkUploadMsg: false,
      logSheetUrl: '',
      responseMsg: "",
      componentKey: 0,
      formData: {
        bulkUpload: false,
        manual: "bulk",
        roleType: ""
      },
      legalEntityList: ["HR", "Accountant", "TeamLead"],
      filterEmpData: [],
      employeeData: [
        // {
        //     id: "db2c478c-b7e7-4b92-a06c-e7dd204f4551",
        //     createdBy: null,
        //     src: "@/assets/user.svg",
        //     updatedBy: null,
        //     customAttr: null,
        //     name: "arpit pandey",
        //     code: "code123",
        //     legal_entity_id: "6fc5a046-4cca-442c-84f7-c7d91afa3338",
        //     official_email_id: "e@id.com",
        //     father_name: "father_name",
        //     mother_name: "mother name",
        //     gender: "male",
        //     marital_status: null,
        //     dob: "2012-12-11T18:30:00.000Z",
        //     anniversary_date: "2012-12-11T18:30:00.000Z",
        //     permanent_address_id: "6fc5a046-4cca-442c-84f7-c7d91afa3338",
        //     communication_address_id: "6fc5a046-4cca-442c-84f7-c7d91afa3338",
        //     phone_number: "9999999999",
        //     mobile_number: "9999999999",
        //     email_id: "e@id.com",
        //     emergency_contact_number: "9999999999",
        //     emergency_contact_name: "arpit",
        //     pan_number: "hjhfskhf",
        //     pan_photo_url: "url",
        //     adhar_number: "fsdfs",
        //     adhar_photo_url: "url",
        //     passport_number: "jfhsdl",
        //     passport_photo_url: "sjhfls",
        //     employee_tax_status: "resident",
        //     photo_url: "url",
        //     created_at: "2019-07-26T06:43:45.545Z",
        //     updated_at: "2019-07-26T07:20:38.521Z"
        // }
      ],
    };
  },
  computed: {
     ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),
    
    le_id() {
      //console.log("le_id call",this.$route.params.entity_index)
      if (this.$route.params.entity_index)
        
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },
    ...mapState({
      legalEntitiesData: state => state.onboard.legal_entities.data,
      currentEmployeeList: state => state.onboard.employees.entityWiseData
    }),

   ...mapState("onboard/organization", {
      orgId: state => state.id,
      orgData: state => state.data[0]
    }),
   
  },
  mounted() {
    //console.log("New component mounted.");
    //console.log("orgId", this.orgId);
    //console.log("LEID",this.le_id);
  },
  activated: function() {
    //console.log("activated");
    this.fetchLegalEntities();
    // this.fetchAllEmployees();
    this.fetchData();
  },
  methods: {
    ...mapActions({
      act_fetch: "onboard/legal_entities/fetchAll",
      act_create: "dashboard/organisation/essManagement/create",
      act_download_bulk_template: "dashboard/organisation/essManagement/downloadESSBulkTemplate",
      act_upload_bulk_template: "dashboard/organisation/essManagement/uploadEssBulk",
      act_fetchEmployees: "onboard/employees/fetchAll",
      act_fetchLegalEntityNonExitsEmployeeSearchList:
        "dashboard/payroll/utilities/addexitemployees/fetchLegalEntityNonExitsEmployeeSearchList",
      fetchEmployeeByLeAndName: "globalapi/globalemployees/fetchByLeAndName"  
    }),
    
    async fetchData() {
      try {
        let res = await this.act_fetchLegalEntityNonExitsEmployeeSearchList({le_id:this.le_id});
        //console.log("Ressssssss",res);
      } catch (err) {
        //console.log("intro error", err);
      }
    },

    async downloadTemplate() {
     try {
      // let payload = {
      //   le_id: this.le_id,
      //   financial_year: this.payrollYear
      // }
       let res = await this.act_download_bulk_template();
     } catch (error) {
       this.toast = true;
       this.errmsg = error;
     }
   },

   async onUploadTemplate(event) {
      let formData = new FormData();
      formData.append("file", event);
      formData.append("le_id", this.le_id);
      try {
        this.$root._data.isSaving = true;
        //let res = await this.act_upload_template(formData); // this is old api
        let res = await this.act_upload_bulk_template(formData); 
        if (res.status == 200) {
          this.responseMsg = "Uploaded Successfully";
          this.showSuccessBulkUploadMsg = true;
          this.logSheetUrl = res.data.payload[0];
        }
        setTimeout(() => {
          this.$root._data.isSaving = false;
        }, 500);
      } catch (error) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },

    back() {
      this.toast = false;
      this.showSuccessBulkUploadMsg = false;
      this.componentKey += 1;
    },
    
    async fetchLegalEntities() {
      try {
        //console.log("essLogin",this.orgId);
        await this.act_fetch(this.orgId);
      } catch (err) {
        //console.log("intro error", err);
      }
    },
    changeHandler(val){
      this.formData.entityType = val.id;
      this.fetchAllEmployees(val.id)
    },
    cancelModal() {
      this.showCreateModal = false;
    },
     backfrompopup() {
      this.showSuccessMsg = false;
      this.$router.push({
         path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities/essManagement`
      });
    },
    backfromlogpopup(){
      this.showSuccessBulkUploadMsg = false;
      this.componentKey += 1;
    },
    manualEntry() {
      //console.log("manual", this.formData.manual);
      this.manual = true;
    },
    bulkUpload() {
      this.manual = false;
    },
     routeToMainStep(){this.$router.push({path:`/dashboard/${this.$route.params.entity_index}/organisation/`})},
    routeToSubStep(){this.$router.push({path:`/dashboard/${this.$route.params.entity_index}/organisation/utilities`})},
    searchData(key, array) {
      const final = [];
      for (let i = 0; i < array.length; i++) {
        let searchObj = array[i].name;
        if (
          searchObj != null &&
          searchObj.toLowerCase().search(key.toLowerCase()) !== -1
        ) {
          final.push(array[i]);
        }
      }
      return final;
    },
    async fetchAllEmployees(leid){
      try {
          await this.act_fetchEmployees(leid)
      } catch (error) {
        //console.log(error);
      }
     },
    searchSelected(employee) {
      //console.log("searchSelected", employee);
      this.formData.emp_id = employee.id;
      this.formData.emailId = employee.email_id;
      this.formData.phoneNumber = employee.mobile_number;
      this.auto_suggestions = false;
      //console.log("name", employee.name);
    },

    filterData(searchText) {
      let data = this.$_.cloneDeep(this.employeeData);
      if (searchText.length) {
        this.auto_suggestions = true;
        this.filterEmpData = this.searchData(searchText, this.employeeData);
      } else {
        this.auto_suggestions = false;
      }
    },

    /** Function to fetch the employees available in that LE by name */
    async searchEmployeesByName(val) {
      try {
        let res = await this.fetchEmployeeByLeAndName({
          le_id: this.le_id,
          key: val
        });
        //console.log("thisisres",res);
        if (res.data.status) {
          this.employeeData = res.data.payload;
        }
      } catch (error) {}
    },

    selectedEmp(emp) {
      //console.log("empObj", emp);
      this.data = emp;
      this.showEmpDetails = true;
    },

    /* Search Logic */
    async performAction() {
      let apirequestObj={
        employee_id:this.data.id,
        le_id:this.le_id,
        email:this.formData.email,
        phoneNumber:"",
        //type:'EMAIL',
        role:this.formData.roleType,
        // userRole:this.formData.roleType,
        name:this.data.first_name,
        ecode: this.data.code,
        org_id:this.orgId,
      }

      try {
        //this.$root._data.isSaving = true;
        let res = await this.act_create({
          ...apirequestObj
        });
        if(res.data.statusCode == 200 || res.data.statusCode == 201) {
          this.showSuccessMsg = true;
        }
        // setTimeout(() => {
        //   this.$root._data.isSaving = false;
        // }, 500);
      } catch (err) {
        //this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },
    refresh(){
      this.formData = {};
    },
      // le_id: this.le_id
    // async save() {
    //   this.$validator.validateAll().then(result => {
    //     if (result) {
    //       //console.log("perform signup", result);
    //     }
    //   });
    // },

    // submit() {
    //   this.$validator.validateAll().then(result => {
    //     if (result) {
    //       //console.log("Submit", result);
    //       this.performAction().then(() => {
    //         this.showSuccessMsg = true;
    //       });
    //     }
    //   });
    // },

    /** To clear the selected employee data */
    clearEmployee() { },
    cancel(){
      this.$router.push({
         path: `/dashboard/${this.$route.params.entity_index}/organisation/utilities`
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/dashboard/_variables.scss"; // Common
@import "@/scss/dashboard/content/_section.scss"; // Content Section
.nav {
  margin-top: 1.7%;
  color: #555555;
  font-size: 11px;
}
.empName label {
  font-size: 16px;
  color: #646464;
  margin-bottom: 4px;
}
.empcode label {
  font-size: 14px;
  color: #878787;
}
[type="radio"]:checked + label {
  position: relative;
  padding-left: 21px;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  font-weight: 600;
  color: #646464;
  margin-right: 32px;
}
[type="radio"]:not(:checked) + label {
  position: relative;
  padding-left: 21px;
  cursor: pointer;
  line-height: 20px;
  display: inline-block;
  font-weight: 600;
  color: #646464;
  margin-right: 32px;
}

.main-header {
  color: #6d6d6d;
  margin-top: 37px;
  font-size: 16px;
}
.upload {
  grid-row: span 2;
  width: 300px;
  line-height: 7px;
}
.half-width {
  width: 26.7%;
}
.search-bar input {
  height: 35px !important;
}
.filters-section {
  display: flex;
  align-items: flex-start;
  margin-top: 30px;
  // overflow: scroll;
  *:not(:last-child) {
    margin-right: 18px;
  }
}
.ver-line {
  border-right: solid 1px #30b6bc;
  padding-top: 10px;
}
.emp-img {
  width: auto;
  text-align: center;
}
.component-wrapper {
  padding: 14px;
}
.custom-width-100 {
  width: 100px;
}

.selectdiv {
  width: 320px !important;
  .input-label {
    opacity: 0.5 !important;
  }
  select {
    max-width: 200px;
    border-radius: 4px;
    outline: 0;
    font-size: 14px;
    color: #9c9c9c;
    border: 1px solid #dadada;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    /* SVG background image */
    // background: url("@/assets/stroke-1.png");
    background-size: 12px;
    background-position: calc(100% - 10px) center;
    background-repeat: no-repeat;

    option {
      color: #9c9c9c;
      font-size: 12px;
    }
  }
  span {
    color: #b3b3b3;
    font-size: 12px;
  }
}
.filters-button {
  margin-top: 10px;
  width: 95px;
  height: 35px;
  cursor: pointer;
  font-size: 12px;
  border-radius: 4px;
  color: #555555;
  border: 1px solid #37c6c0;
}
.search-bar {
  padding: 30px 0px 30px 0px;
  display: flex;
}

.label-text {
  font-size: 12px;
  font-weight: 400;
  color: #6e6e6e;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.export-section {
  margin-left: 6%;
  margin-top: 5px;
  align-items: center;
  display: flex;
  justify-content: flex-end;
}
.export-button {
  width: 60px;
  height: 20px;
  border-radius: 4px;
  font-family: Montserrat;
  font-size: 12px;
  text-align: center;
  border: 1px solid #5d409f;
  color: #5d409f;
  margin-left: 3px;
}
.export-section {
  margin-left: 26%;
  margin-top: 5px;
  align-items: center;
  display: flex;
}
.export-button {
  width: 60px;
  height: 20px;
  border-radius: 4px;
  font-family: Montserrat;
  font-size: 12px;
  text-align: center;
  border: 1px solid #5d409f;
  color: #5d409f;
  margin-left: 3px;
}
.sort-by {
  display: flex;
  margin-left: 1%;

  span {
    margin-right: 10px;
    margin-top: 10px;
    color: #b3b3b3;
    font-size: 12px;
  }
}
.side-actions {
  margin-left: 10px;
  margin-top: 10px;
  img {
    cursor: pointer;
    margin-right: 5px;
    margin-left: 5px;
  }
}
.ht-35 {
  padding:10px;
  .tl-textfield input,
  select {
    height: 30px !important;
  }
}
.employee-cards {
  padding: 30px 0 0 10px;
}
.group-btn {
  margin: 40px 0px;
}
// .search-bar{
//     position: relative;
// }
.search-result {
  position: absolute;
  width: 320px;
  background: #ffffff;
  max-height: 368px;
  border-radius: 4px;
  border: solid 1px #f7f7f7;
  overflow: auto;
  li {
    padding: 15px;
    border-bottom: 0.5px solid #e3e3e3;
    margin-right: 0px !important;
    &:hover {
      background-color: #d6f2f2;
    }
  }
}
.threeColumnGrid {
  grid-column-gap: 0px;
}
.img-part {
  img {
    width: 100%;
  }
}
</style>
